import { render, staticRenderFns } from "./RolesSelectionDialog.vue?vue&type=template&id=4ccc40dc"
import script from "./RolesSelectionDialog.vue?vue&type=script&lang=js"
export * from "./RolesSelectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports